import { createIntegrationSettingsRoute } from '../integrationSettingsRoute';

const Index = () => import('./Index.vue');

export default createIntegrationSettingsRoute({
  path: 'accounts/:accountId/settings/ura-integration',
  headerTitle: 'URA_INTEGRATION_SETTINGS.HEADER',
  routeName: 'settings_ura_integration',
  component: Index,
  roles: ['administrator', 'master'],
});
